export const EXPORT_FIELDS_EXAMPLE = {
  'INTEGER': '1000',
  'DATE': '19/02/2022',
  'HOUR': '23:13',
  'FLOAT': '1000,10',
  'CURRENCY': '€',
  'TagTypeEntity': 'example',
  'STRING': 'example',
  'BOOLEAN': 'true'
}
